import React from "react";
import { useStyles } from "./MobileStyle.jsx";
import { Grid, Typography, Box } from "@material-ui/core/";
import teamIMG from "../../../assets/team.png";

export default function HomePage() {
  const classes = useStyles();

  return (
    <div>
        <Box className = { classes.box}>
            <Grid className={classes.grid}>
                <Grid container >
                    <Grid item xs={7}>
                    <Typography className={classes.title}>
                        "Faça sua Solicitação de Cadastro"
                    </Typography>
                    </Grid>
                    <Grid item xs={5}>
                    <img src={teamIMG} alt="imagem ilustrativa de uma equipe médica feliz"  className={classes.image} />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
        
        <Box className = { classes.box}>
            <Grid className = { classes.alertContainer } container spacing = {2}>
                <Grid item xs = {12}>
                    <Typography className={classes.alertTitle}>
                        Por favor, acesse em um computador.
                    </Typography>
                </Grid>
                <Grid item xs = {12}>
                    <Typography className={classes.alertSubTitle}>
                    Acesse essa página em um computador para preencher os formulários e enviar os anexos necessários. Ainda não é possível fazer isso usando um celular ou tablet.
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    </div>
  );
}
